/*!

=========================================================
* Central System - v1.0.0
=========================================================

* Coded by Aircode

=========================================================

*/
import React from "react";
import './Footer.css'

// reactstrap components
import {
    Container,
    Row,
    Col,
} from "reactstrap";

class Footer extends React.Component {

    render() {
        return (
            <section className="section section-lg footer-section pb-1">
                <Container className="py-1">
                    
                    <Row className="row-grid mt-5">
                        <Col lg="3">
                            
                            <h6 className="mt-2">Who we are</h6>
                            <hr/>
                            <p className="mt-3">
                                The Fred S. Keller School, named for the behavior analyst and pioneer 
                                'in experimental psychology, Fred Simmons Keller, is an internationally
                                recognized behavior analytic preschool and early intervention program for 
                                children from eighteen months through age five with and without disabilities.
                            </p>
                        </Col>
                        <Col lg="4">
                            
                            <h6 className="mt-2">Help and Support</h6>
                            <hr/>
                            <Row>
                                <Col className="mr-3" lg="5">
                                    <ul className="list-inline">
                                        <li>
                                            <a 
                                                href="/faq" 
                                                className="text-gray"
                                                target="_self"
                                            >
                                                FAQs
                                            </a>
                                        </li>
                                        <li>
                                            <a 
                                                href="https://fredskellerschool.com/faqs" 
                                                className="text-gray"
                                                target="_blank"
                                            >
                                                School FAQ
                                            </a>
                                        </li>
                                        
                                    </ul>
                                </Col>
                                <Col className="mr-3" lg="5">
                                    <ul className="list-inline" >
                                        
                                        <li>
                                            <a 
                                                href="https://fredskellerschool.com/contact-us" 
                                                className="text-gray"
                                                target="_blank"
                                            >
                                                Contact Us
                                            </a>
                                        </li>
                                    </ul>
                                </Col>
                                
                            </Row>
                        </Col>
                        <Col lg="3">

                            <h6 className="mt-2">Privacy and Terms</h6>
                            <hr/>
                            <ul className="list-inline">
                                <li>
                                    <a 
                                        href="/terms" 
                                        className="text-gray"
                                        target="_self"
                                    >
                                        Terms
                                    </a>
                                </li>
                                <li>
                                    <a 
                                        href="/privacy" 
                                        className="text-gray"
                                        target="/self"
                                    >
                                        Privacy Policy
                                    </a>
                                </li>
                            </ul>
                        </Col>
                        <Col lg="2">

                            <h6 className="mt-2">Social Media</h6>
                            <hr/>
                            <ul className="list-inline">
                                <li>
                                    <a 
                                        href="https://www.linkedin.com/company/fred-s-keller-schools/posts/?feedView=all" 
                                        target="_blank"
                                        className="text-gray"
                                    >
                                            Linkedin
                                    </a>
                                </li>
                            </ul>
                        </Col>
                    </Row>

                    <Row className="row-grid mt-5 copyright-text" >
                        <Col lg="12">
                            <p className="text-center">
                                Copyright © 2025 Fred S. Keller. <br/>                                
                                Powered by <a 
                                        href="https://www.tactini.com/" 
                                        target="_blank"
                                        className="text-gray"
                                    >Tactini</a>
                            </p>
                        </Col>
                        
                    </Row>
                </Container>

            </section>

        )
    }
}

export default Footer;

